import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Lock, ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  showPrice?: boolean;
  className?: string;
}
export function CTAButton({
  text = 'Domina el arco ahora',
  showPrice = false,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-md mx-auto ${className}`} data-id="element-57">
      {showPrice && <div className="mb-3 text-center" data-id="element-58">
          <span className="text-gray-400 line-through text-lg mr-2 font-medium" data-id="element-59">
            $54.900
          </span>
          <span className="text-green-700 font-black text-3xl" data-id="element-60">$19.990</span>
          <p className="text-sm text-gray-500 mt-1 font-medium" data-id="element-61">
            Pago único. Acceso de por vida.
          </p>
        </div>}

      <motion.a href="https://checkout.ebookpoint.shop/cart/59698360811601:1" className="w-full bg-green-600 hover:bg-green-700 text-white font-black text-xl py-5 px-8 rounded-xl shadow-[0_8px_0_rgb(21,128,61)] hover:shadow-[0_4px_0_rgb(21,128,61)] hover:translate-y-1 transition-all duration-200 flex items-center justify-center gap-3 text-center uppercase tracking-wide" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-62">
        <ShoppingCart className="w-6 h-6" data-id="element-63" />
        {text}
      </motion.a>

      <div className="flex items-center justify-center gap-4 mt-4 text-xs text-gray-500 font-medium" data-id="element-64">
        <span className="flex items-center gap-1" data-id="element-65">
          <Lock className="w-4 h-4 text-gray-400" data-id="element-66" />
          Pago 100% Seguro
        </span>
        <span className="flex items-center gap-1" data-id="element-67">
          <ShieldCheck className="w-4 h-4 text-gray-400" data-id="element-68" />
          Garantía de Satisfacción
        </span>
      </div>
    </div>;
}